module.exports = __webpack_public_path__ + "resources/img/img_tibero5.1386feb555a8d46d3a39b6be83fab8a2.png";